import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from 'trans'
import { AxiosResponse } from 'axios'
import * as d3 from "d3"

import { map, sortBy, forEach, find, debounce, uniq, omitBy, escapeRegExp, template, update } from "lodash"

import {
    css,
    GridCell,
    Theme,
    Div,
} from "@bdfx/mergado-ui-kit"

import  { IMAGE_FROM_ELEMENTS_TYPE, RATING_TYPE, RESIZE_TYPES_TO_CHANGE_FONTSIZE, SOURCE_IMAGE_TYPE, TEXT_SHAPE_TYPES } from 'shape-entities/types/shape';
import Shape, { CoordsType, CoordsWithMiddleType } from "shape-entities/components/shape"
import { EditModeType, GuideLines, GuidesType } from "app/types/app-types";
import { Gradient, SettingsFormType, SizeType } from "app/types/model-types";
import ShapeType, { BADGE1_TYPE, BADGE_TYPE, BEZIER_TYPE, BITMAP_TYPE, BRUSH_TYPE, CIRCLE_TYPE, CURVED_TEXT_TYPE, CUSTOM_SET_TYPE, DYNAMIC_TEXT_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE, TEXT_INSIDE_SHAPE_TYPE, RECTANGLE_TYPE, TEXT_TYPE, TEXT_WITH_ELEMENTS_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE, NO_TEXT_CURSOR_TYPES } from "shape-entities/types/shape"
import { RandomProduct } from "shape-edit/types";
import { ACTIVE_VIEW_EDIT_SHAPE, ACTIVE_VIEW_EDIT_SOURCE_IMAGE, ACTIVE_VIEW_NEW_SHAPE, ACTIVE_VIEW_SHAPE_SELECTION, ActiveViewType } from "./Editor"

import { setDragging } from "template-edit/reducers"
import { updateInputValue as change } from "app/reducers/form"
import { setActiveView, setActiveShapeId, setActiveGroupId } from "shape-edit/reducers";

import {
    calculateGroupSizeAndPosition,
    createGroupFromSelected,
    getGridMinApproachPx,
    getHandleSize,
    getScaledShapeSizeAndAngle,
    getRotateHandleSize, getShapeSize, getTemplateSize, replaceDynamicTextWithProductData,
    rotateSelectedShapes,
    GroupSizeAndPosition,
    initCalculatedGroupSizeAndPosition,
    calcObjectCorners,
    getFormName,
} from "shape-edit/forms/helpers";

import { iconDisabledColor } from "../components/tools-panel";
import { selectLayers, toggleLockLayer, toggleSelectLayer } from "shape-list/reducers";
import SourceImageSvg from "shape-entities/components/source-image-svg";
import { GradientDefs, GradientFillUrl } from "shape-edit/forms/fields";
import { EXCLUDE_ASPECT_SIZE_RATIO_TYPES, isPointShapeType, shouldAspectRatio } from 'shape-entities/defaults';
import { getTemplateGradientAndBackground, SOURCE_IMAGE_INDEX } from 'shape-edit/forms/helpers';

import {
    END_KEY,
    BACKSCAPE_KEY,
    DELETE_KEY,
    DOWN_ARROW_KEY,
    ENTER_KEY,
    HOME_KEY,
    INSERT_KEY,
    LEFT_ARROW_KEY,
    MINUS_KEY,
    PAGE_DOWN_KEY,
    PAGE_UP_KEY,
    PLUS_KEY,
    RIGHT_ARROW_KEY,
    UP_ARROW_KEY
} from "app/helpers/keymap";

import { isJson } from 'app/helpers/other'
import { getUpdatedShapeOrFontSize, renderClipMaskShape, testUsers } from 'template-edit/components/helper'
import { selectFormValues } from 'app/reducers/form'
import { getDirectionFromDeltaPositions, recalcClipMaskSizeAndPositions, scaleBrushStrokes, scalePoints } from 'shape-edit/forms/delta-positions-helper'
import { URL } from 'app/config/api-config'
import DraggableRectangle, { DRAGGABLE_ARROW_OPACITY, DRAGGABLE_RECTANGLE_OPACITY, ResizeElementType } from 'shape-entities/components/draggable-rectangle'
import { ReactMouseSelect } from 'react-mouse-select'
import { IconChain, IconChainBroken, IconDelete, IconGroupUnGroup, IconLock, IconLockOpen } from 'app/icons'
import { LevelsModeType } from 'template-edit/components/save-template-form'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'
import { setEditMode } from 'actions'


export const SELECTABLE_CLASS = 'mouse-select__selectable'
export const SHAPE_ID_PREFIX = 'shape_'

export type DeltaPositionsType = {
    x1: number
    y1: number
    x2: number
    y2: number
    index?: string
    type?: ResizeElementType
}

export const initDeltaPositions: DeltaPositionsType = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    index: null,
    type: null,
}

export const MIN_ZOOM = .5
export const MAX_ZOOM = 12
export const ZOOM_STEP = .05

interface Props {
    editMode: EditModeType
    levels: string[]
    levelsMode: LevelsModeType
    shapes: ShapeType[]
    gradients: Gradient[]
    settingsForm: SettingsFormType
    form: TemplateOrAlternativeTemplateType
    activeView: ActiveViewType
    activeShapeId: string | number
    activeGroupId: string
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    selectLayers: typeof selectLayers
    setActiveView: typeof setActiveView
    setEditMode: typeof setEditMode
    setDragging: typeof setDragging
    toggleSelectLayer: typeof toggleSelectLayer
    toggleLockLayer: typeof toggleLockLayer
    change: typeof change
    sameImageInPreview: boolean
    toggleSameImageInPreview: Function
    randomProduct: RandomProduct
    selectedLayers: string[]
    lockedLayers: string[]
    guides: GuidesType
    isDragging: boolean
    isAlt: boolean
    updateZoom: Function
    updateTranslate: Function
    canvasZoom: number
    canvasTranslate: CoordsType
    mouseOverShape: string
    setMouseOverShape: Function
    showOverlap: boolean
    setShowOverlap: Function
    isLoading: boolean
    userId: number
}

interface State {
    deltaAngle: number
    deltaPositions: DeltaPositionsType
    groupDeltaAngle: number
    groupDeltaPositions: DeltaPositionsType
    calculatedGroupSizeAndPosition: GroupSizeAndPosition
    guideLines: GuideLines
    activeShapeCorners: CoordsWithMiddleType
    activeShapeDirection: string
    canvasBox: DOMRect
    snappedToX: number
    snappedToY: number
    isSelecting: boolean
}

const { max, abs, sin, cos, PI, round, atan2, sqrt } = Math

export const DEFAULT_CURSOR = 'default'
export const ROTATE_CURSOR = `url('${URL.publicPath}/img/cursors/rotate-light.cur') -16 16, pointer`
export const MOVE_CURSOR_2 = `url('${URL.publicPath}/img/cursors/move.svg') -16 16, pointer`
export const MOVE_CURSOR = 'move'
export const COPY_CURSOR = 'copy'
export const POINTER_CURSOR = 'pointer'
export const GRABBING_CURSOR = 'grabbing'
export const ALL_SCROLL_CURSOR = 'all-scroll'


/*
TODO: cursor follow ref:

cursorFollowRef: React.RefObject<SVGCircleElement>
     this.cursorFollowRef = React.createRef()


    handleMouseMove = (e) => {
        const el = this.cursorFollowRef.current
        console.debug('handle mouse move', e, el)
        if (el) {
            el.setAttribute('cx', e.pageX)
            el.setAttribute('cy', e.pageY)
            //el.style.top = e.pageY
        }
    }

document.addEventListener("mousemove", this.handleMouseMove)
document.removeEventListener('mousemove', this.handleMouseMove)

image-preview.tsx: <circle
                            ref={this.cursorFollowRef}
                            id={''}
                            r={20}
                            stroke='#aaaaaa'
                            fill='none'
                            strokeWidth='2'
                        />
 */

class ImagePreview extends Component<Props, State> {
    groupHandleRefs: React.RefObject<SVGRectElement | SVGCircleElement>[] = []
    mouseSelectContainerRef: React.RefObject<any>

    constructor(props) {
        super(props)

        this.state = {
            calculatedGroupSizeAndPosition: initCalculatedGroupSizeAndPosition,
            guideLines: null,
            activeShapeCorners: null,
            activeShapeDirection: null,
            canvasBox: null,
            deltaAngle: 0,
            groupDeltaAngle: 0,
            deltaPositions: { ...initDeltaPositions },
            groupDeltaPositions: { ...initDeltaPositions },
            snappedToX: null,
            snappedToY: null,
            isSelecting: false,
        }

        this.mouseSelectContainerRef = React.createRef()
    }

    setGroupDeltaPositions = (groupDeltaPositions: DeltaPositionsType, type: ResizeElementType = null) => {
        const {groupWidth, groupHeight, middleX, middleY, groupAngle} = this.state.calculatedGroupSizeAndPosition
            const dx = (groupDeltaPositions.x1 + groupDeltaPositions.x2) / 2
            const dy = (groupDeltaPositions.y1 + groupDeltaPositions.y2) / 2

            const dw = groupDeltaPositions.x2 - groupDeltaPositions.x1
            const dh = groupDeltaPositions.y2 - groupDeltaPositions.y1

            const alphaRadians = (groupAngle || 0)/180*PI
            const c = cos(alphaRadians)
            const s = sin(alphaRadians)

            const activeGroupCorners = calcObjectCorners(
                middleX + dx * c - dy * s,
                middleY + dx * s + dy * c,
                groupWidth + dw,
                groupHeight + dh,
                groupAngle + this.state.groupDeltaAngle
            )

        const isMoving = groupDeltaPositions.x1 === groupDeltaPositions.x2 && groupDeltaPositions.y1 === groupDeltaPositions.y2 &&
            groupDeltaPositions.x1 !== 0 && groupDeltaPositions.y1 !== 0

        this.setState({
            activeShapeCorners: activeGroupCorners,
            activeShapeDirection: getDirectionFromDeltaPositions(dx, dy),
            groupDeltaPositions: isMoving ?
                this.snapToGridMoving({ ...groupDeltaPositions }, activeGroupCorners) :
                this.snapToGridResizing({ ...groupDeltaPositions }, activeGroupCorners, 0, { width: groupWidth, height: groupHeight })
        })
    }

    setgroupDeltaAngle = (groupDeltaAngle: number) => {
        this.setState({ groupDeltaAngle: groupDeltaAngle })
    }

    setDeltaAngle = (deltaAngle: number) => {
        this.setState({ deltaAngle: deltaAngle })
    }

    setDeltaPositions = (requestedDeltaPositionsOrig: DeltaPositionsType) => {
        const { form } = this.props
        if (this.props.activeShapeId && form?.shapes[this.props.activeShapeId]) {
            const activeShape: ShapeType = form.shapes[this.props.activeShapeId]
            const activeShapeSize = getShapeSize(activeShape)
            const isPointType = isPointShapeType(activeShape.type)
            const isBrushType = activeShape.type === BRUSH_TYPE

            const shapeSize = getShapeSize(activeShape)

            const isKeepTextRatio = TEXT_SHAPE_TYPES.includes(activeShape.type) && RESIZE_TYPES_TO_CHANGE_FONTSIZE.includes(requestedDeltaPositionsOrig.type) && activeShape.text_fontsize
            const keepSizeRatio = (activeShape.is_aspect_size_ratio /* || isKeepTextRatio */) && shapeSize.width && shapeSize.height ? shapeSize.width / shapeSize.height : null

            //adjust deltapositions to maintain the size ratio (before activeShapeCorners are calculated)
            const requestedDeltaPositions = this.keepSizeRatioAndMinSize(requestedDeltaPositionsOrig, keepSizeRatio, activeShape)
            //const requestedDeltaPositions = requestedDeltaPositionsOrig   //debug only

            const dx = (requestedDeltaPositions.x1 + requestedDeltaPositions.x2) / 2
            const dy = (requestedDeltaPositions.y1 + requestedDeltaPositions.y2) / 2

            const dw = requestedDeltaPositions.x2 - requestedDeltaPositions.x1
            const dh = requestedDeltaPositions.y2 - requestedDeltaPositions.y1

            const alphaRadians = (activeShape.angle || 0)/180*PI
            const c = cos(alphaRadians)
            const s = sin(alphaRadians)

            const activeShapeCorners = calcObjectCorners(
                activeShape.x + dx * c - dy * s,
                activeShape.y + dx * s + dy * c,
                activeShapeSize.width + dw,
                activeShapeSize.height + dh,
                activeShape.angle + this.state.deltaAngle
            )

            const isMoving = requestedDeltaPositionsOrig.x1 === requestedDeltaPositionsOrig.x2 && requestedDeltaPositionsOrig.y1 === requestedDeltaPositionsOrig.y2 &&
                requestedDeltaPositionsOrig.x1 !== 0 && requestedDeltaPositionsOrig.y1 !== 0

            this.setState({
                activeShapeCorners: activeShapeCorners,
                activeShapeDirection: getDirectionFromDeltaPositions(dx, dy),
                deltaPositions: !isPointType && !isBrushType ? (
                    isMoving ?
                        this.snapToGridMoving({ ...requestedDeltaPositions }, activeShapeCorners) :
                        this.snapToGridResizing({ ...requestedDeltaPositions }, activeShapeCorners, keepSizeRatio, activeShapeSize)
            ) : { ...requestedDeltaPositions }
            })
        }
    }

    updateGuidelinesStateForAllShapes = (shapes: ShapeType[]) => {
        const { guides, activeShapeId, form } = this.props

        if (!guides || !guides.isSnapOn || guides.gridStepMode > 0 || guides.isShowGrid) {
            return;
        }

        let verticalGuidelines: number[] = []   //x1,..,xn
        let horizontalGuidelines: number[] = [] //y1,..,yn

        //add canvas boundaries:
        const templateSize = getTemplateSize(form)
        if (templateSize.width && templateSize.height) {
            verticalGuidelines = [0, templateSize.width]
            horizontalGuidelines = [0, templateSize.height]
        }

        //add shapes boundaries (except the active shape and source image):
        forEach(shapes, shape => {
            if (shape.index !== activeShapeId && shape.type !== SOURCE_IMAGE_TYPE && !shape.is_hidden && !isPointShapeType(shape.type)) {
                const shapeSize = getShapeSize(shape)
                const objectCorners = calcObjectCorners(shape.x, shape.y, shapeSize.width, shapeSize.height, (shape.angle || 0))

                verticalGuidelines.push(objectCorners.topLeft.x)
                verticalGuidelines.push(objectCorners.middle.x)
                verticalGuidelines.push(objectCorners.bottomRight.x)

                horizontalGuidelines.push(objectCorners.topLeft.y)
                horizontalGuidelines.push(objectCorners.middle.y)
                horizontalGuidelines.push(objectCorners.bottomRight.y)
            }
        })

        const newGuidelines: GuideLines = {
            x: verticalGuidelines ? uniq(sortBy(verticalGuidelines)) : null,
            y: horizontalGuidelines ? uniq(sortBy(horizontalGuidelines)) : null,
        }

        this.setState({ guideLines: newGuidelines })
    }

    isMultiselect = () : boolean => {
        const { calculatedGroupSizeAndPosition, groupDeltaPositions } = this.state
        return !!(this.props.selectedLayers && this.props.selectedLayers.length > 1 && calculatedGroupSizeAndPosition.groupWidth && calculatedGroupSizeAndPosition.groupHeight && groupDeltaPositions)
    }

    snapToGridMoving = (deltaPositions: DeltaPositionsType, activeShapeCorners: CoordsWithMiddleType): DeltaPositionsType => {
        const { guides } = this.props
        const { guideLines } = this.state

        if (guides && guides.isSnapOn && guideLines && activeShapeCorners) {    //is snap possible?
            let correctX = 0
            let correctY = 0
            let snappedToX = null
            let snappedToY = null

            if (!guides.isShowGrid && guides.isShowGuides) {
                if (guideLines.x && guideLines.x.length > 0) {
                    guideLines.x.forEach(x => {
                        const d1 = activeShapeCorners.topLeft.x - x
                        const d2 = activeShapeCorners.bottomRight.x - x
                        const d3 = activeShapeCorners.middle.x - x

                        //side to side:
                        if (d1 <= guides.minApproachX && -d1 <= 2 * guides.minApproachX) {
                            correctX = -d1
                            snappedToX = activeShapeCorners.topLeft.x - d1
                        }

                        //which one is closer to the object (left/right)?
                        if (d2 <= guides.minApproachX && -d2 <= 2 * guides.minApproachX && (correctX === 0 || d2 < d1)) {
                            correctX = -d2
                            snappedToX = activeShapeCorners.bottomRight.x - d2
                        }

                        //only middle to middle:
                        if (d3 <= guides.minApproachX && -d3 <= 2 * guides.minApproachX && (correctX === 0 || d3 < correctX)) {
                            correctX = -d3
                            snappedToX = activeShapeCorners.middle.x - d3
                        }
                    })
                }

                if (guideLines.y && guideLines.y.length > 0) {
                    guideLines.y.forEach(y => {
                        const d1 = activeShapeCorners.topLeft.y - y
                        const d2 = activeShapeCorners.bottomRight.y - y
                        const d3 = activeShapeCorners.middle.y - y

                        if (d1 <= guides.minApproachY && -d1 <= 2 * guides.minApproachY) {
                            correctY = -d1
                            snappedToY = activeShapeCorners.topLeft.y - d1
                        }

                        //which one is closer to the object (bottom/top)?
                        if (d2 <= guides.minApproachY && -d2 <= 2 * guides.minApproachY && (correctY === 0 || d2 < d1)) {
                            correctY = -d2
                            snappedToY = activeShapeCorners.bottomRight.y - d2
                        }

                        if (d3 <= guides.minApproachY && -d3 <= 2 * guides.minApproachY && (correctY === 0 || d3 < correctY)) {
                            correctY = -d3
                            snappedToY = activeShapeCorners.middle.y - d3
                        }
                    })
                }
            } else if (guides.isShowGrid) {
                const minApproachPx = getGridMinApproachPx(guides.gridStep)

                //horizontal:
                const d1 = this.nearestDiff(activeShapeCorners.topLeft.x)
                const d2 = this.nearestDiff(activeShapeCorners.bottomRight.x)
                const d3 = this.nearestDiff(activeShapeCorners.middle.x)

                if (abs(d1) <= minApproachPx) {
                    correctX = -d1
                }

                if (abs(d2) <= minApproachPx && (correctX === 0 || d2 < d1)) {
                    correctX = -d2
                }

                if (abs(d3) <= minApproachPx && (correctX === 0 || d3 < correctX)) {
                    correctX = -d3
                }

                //vertical:
                const e1 = this.nearestDiff(activeShapeCorners.topLeft.y)
                const e2 = this.nearestDiff(activeShapeCorners.bottomRight.y)
                const e3 = this.nearestDiff(activeShapeCorners.middle.y)

                if (e1 <= guides.minApproachY && -e1 <= minApproachPx) {
                    correctY = -e1
                }

                if (e2 <= guides.minApproachY && -e2 <= minApproachPx && (correctY === 0 || e2 < e1)) {
                    correctY = -e2
                }

                if (e3 <= guides.minApproachY && -e3 <= minApproachPx && (correctY === 0 || e3 < correctY)) {
                    correctY = -e3
                }
            }

            this.setState({
                snappedToX: snappedToX,
                snappedToY: snappedToY,
            })

            return {
                x1: deltaPositions.x1 + correctX,
                x2: deltaPositions.x2 + correctX,
                y1: deltaPositions.y1 + correctY,
                y2: deltaPositions.y2 + correctY,
                index: deltaPositions.index,
                type: deltaPositions.type,
            }
        }

        return deltaPositions
    }

    keepSizeRatioAndMinSize = (origDeltaPositions: DeltaPositionsType, keepSizeRatio: number, activeShape: ShapeType): DeltaPositionsType => {
        const activeShapeSize = getShapeSize(activeShape)

        let newDeltaPositions = { ...origDeltaPositions }

        // Min text size enforcement — requires DOM measurement, must stay here
        /* if ([CIRCLE_TYPE, RECTANGLE_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE, TEXT_TYPE, DYNAMIC_TEXT_TYPE, TEXT_WITH_ELEMENTS_TYPE, RATING_TYPE].includes(activeShape.type)) {
            let realWidth: number
            let realHeight: number
            let padding: number

            if (activeShape.type === RATING_TYPE) {
                const ns = getRatingShapeSize(activeShape.text_fontsize, activeShape.text_padding, activeShape.stroke_width)
                realWidth = ns.width
                realHeight = ns.height
                padding = 0
            } else {
                const rs = getRealSizeByElementId(`shape_${activeShape.index}`, activeShape.text_fontsize)
                realWidth = rs.realWidth
                realHeight = rs.realHeight
                padding = getTextPadding(activeShape.text_fontsize, activeShape.text_overflow)
            }
        } */

        const updatedShape = getUpdatedShapeOrFontSize(activeShape, newDeltaPositions, keepSizeRatio)

        if (!updatedShape) {
            return newDeltaPositions
        }

        // Derive delta positions from the updated shape (inverse of the rotation transform in getUpdatedShapeOrFontSize)
        const dw = updatedShape.width - activeShapeSize.width
        const dh = updatedShape.height - activeShapeSize.height

        const a = (activeShape.angle ?? 0) * PI / 180

        const c = cos(a)
        const s = sin(a)

        const dx = (updatedShape.x - activeShape.x) * c + (updatedShape.y - activeShape.y) * s
        const dy = -(updatedShape.x - activeShape.x) * s + (updatedShape.y - activeShape.y) * c

        return {
            x1: round(dx - dw / 2),
            x2: round(dx + dw / 2),
            y1: round(dy - dh / 2),
            y2: round(dy + dh / 2),
            index: origDeltaPositions.index,
            type: origDeltaPositions.type,
        }
    }

    snapToGridResizing = (deltaPositions: DeltaPositionsType, activeShapeCorners: CoordsWithMiddleType, keepSizeRatio: number, activeShapeSize: SizeType): DeltaPositionsType => {
        const { guides } = this.props
        const { guideLines } = this.state

        if (guides && guides.isSnapOn && guideLines && activeShapeCorners) {    //is snap possible?
            let correctX = 0
            let correctY = 0
            let snappedToX = null
            let snappedToY = null

            let pointX = null
            let pointY = null

            switch (deltaPositions.type) {
                case 'top':
                    pointX = .5 * (activeShapeCorners.topLeft.x + activeShapeCorners.bottomRight.x);
                    pointY = activeShapeCorners.topLeft.y;
                    break;
                case 'left':
                    pointX = activeShapeCorners.topLeft.x;
                    pointY = .5 * (activeShapeCorners.topLeft.y + activeShapeCorners.bottomRight.y);
                    break;
                case 'right':
                    pointX = activeShapeCorners.bottomRight.x;
                    pointY = .5 * (activeShapeCorners.topLeft.y + activeShapeCorners.bottomRight.y);
                    break;
                case 'bottom':
                    pointX = .5 * (activeShapeCorners.topLeft.x + activeShapeCorners.bottomRight.x);
                    pointY = activeShapeCorners.bottomRight.y;
                    break;
                case 'topleft':
                    pointX = activeShapeCorners.topLeft.x;
                    pointY = activeShapeCorners.topLeft.y;
                    break;
                case 'topright':
                    pointX = activeShapeCorners.bottomRight.x;
                    pointY = activeShapeCorners.topLeft.y;
                    break;
                case 'bottomleft':
                    pointX = activeShapeCorners.topLeft.x;
                    pointY = activeShapeCorners.bottomRight.y;
                    break;
                case 'bottomright':
                    pointX = activeShapeCorners.bottomRight.x;
                    pointY = activeShapeCorners.bottomRight.y;
                    break;
            }

            if (!guides.isShowGrid && guides.isShowGuides) {
                const minApproachX = guides.minApproachX
                const minApproachY = guides.minApproachY

                if (guideLines.x && guideLines.x.length > 0) {
                    guideLines.x.forEach(x => {
                        if (pointX !== null && (abs(pointX - x) <= 2.5 * minApproachX)) {
                            correctX = x - pointX
                            snappedToX = x
                        }
                    })
                }

                if (guideLines.y && guideLines.y.length > 0) {
                    guideLines.y.forEach(y => {
                        if (pointY !== null && (abs(pointY - y) <= 2.5 * minApproachY)) {
                            correctY = y - pointY
                            snappedToY = y
                        }
                    })
                }
            } else if (guides.isShowGrid) {
                const minApproachPx = getGridMinApproachPx(guides.gridStep)

                //horizontal:
                const d = this.nearestDiff(pointX)
                if (abs(d) <= minApproachPx) {
                    correctX = -d
                }

                //vertical
                const e = this.nearestDiff(pointY)
                if (abs(e) <= minApproachPx) {
                    correctY = -e
                }
            }

            //change state:
            this.setState({
                snappedToX: snappedToX,
                snappedToY: snappedToY,
            })

            let x1 : number = 0
            let x2 : number = 0
            let y1 : number = 0
            let y2 : number = 0

            switch (deltaPositions.type) {
                case 'bottomright':
                    x2 = deltaPositions.x2 + correctX
                    y2 = deltaPositions.y2 + correctY
                    break;
                case 'bottomleft':
                    x1 = deltaPositions.x1 + correctX
                    y2 = deltaPositions.y2 + correctY
                    break;
                case 'topleft':
                    x1 = deltaPositions.x1 + correctX
                    y1 = deltaPositions.y1 + correctY
                    break;
                case 'topright':
                    x2 = deltaPositions.x2 + correctX
                    y1 = deltaPositions.y1 + correctY
                    break;
                case 'top':
                    y1 = deltaPositions.y1 + correctY
                    break;
                case 'bottom':
                    y2 = deltaPositions.y2 + correctY
                    break;
                case 'left':
                    x1 = deltaPositions.x1 + correctX
                    break;
                case 'right':
                    x2 = deltaPositions.x2 + correctX
                    break;
            }

            if (keepSizeRatio) {
                const dw = x2 - x1
                const dh = y2 - y1

                const X2ByX = dw
                const X2ByY = (activeShapeSize.height + dh) * keepSizeRatio - activeShapeSize.width

                const X1ByX = -X2ByX
                const X1ByY = -X2ByY

                const Y2ByX = (activeShapeSize.width + dw) / keepSizeRatio - activeShapeSize.height
                const Y2ByY = dh

                const Y1ByX = -Y2ByX
                const Y1ByY = -Y2ByY

                const byX = (!snappedToX && !snappedToY && abs(dw) < abs(dh)) || (snappedToX && !snappedToY) || (snappedToX && snappedToY && abs(correctX) < abs(correctY))

                switch (deltaPositions.type) {
                    case 'bottomright':
                        x2 = byX ? X2ByX : X2ByY
                        y2 = byX ? Y2ByX : Y2ByY
                        break;
                    case 'bottomleft':
                        x1 = byX ? X1ByX : X1ByY
                        y2 = byX ? Y2ByX : Y2ByY
                        break;
                    case 'topleft':
                        x1 = byX ? X1ByX : X1ByY
                        y1 = byX ? Y1ByX : Y1ByY
                        break;
                    case 'topright':
                        x2 = byX ? X2ByX : X2ByY
                        y1 = byX ? Y1ByX : Y1ByY
                        break;
                    case 'top':
                        x1 = -.5*X2ByY
                        x2 = .5*X2ByY
                        break;
                    case 'bottom':
                        x1 = -.5*X2ByY
                        x2 = .5*X2ByY
                        break;
                    case 'left':
                        y1 = -.5 * Y2ByX
                        y2 = .5 * Y2ByX
                        break;
                    case 'right':
                        y1 = -.5 * Y2ByX
                        y2 = .5 * Y2ByX
                        break;
                }
            }

            return {x1, x2, y1, y2, index: deltaPositions.index, type: deltaPositions.type}
        }

        return deltaPositions
    }

    nearestDiff = (value: number): number => {
        const { guides } = this.props
        return value - round(value / guides.gridStep) * guides.gridStep
    }

    handleZoom = (newZoom: number, translate?: CoordsType) => {
        const { activeShapeId, shapes, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        if (activeShapeId && form.size?.width && form.size?.height) {
            const activeShape = shapes[activeShapeId] ?? null

            const MIN_SHAPE_SIZE = 3
            const MAX_SHAPE_SIZE = 2 * max(form.size.width, form.size.height)   //MAX ZOOM

            if (activeShape &&
                (!activeShape.width || activeShape.width * newZoom > MIN_SHAPE_SIZE) &&
                (!activeShape.width || activeShape.width * newZoom < MAX_SHAPE_SIZE) &&
                (!activeShape.height || activeShape.height * newZoom > MIN_SHAPE_SIZE) &&
                (!activeShape.height || activeShape.height * newZoom < MAX_SHAPE_SIZE)
            ) {
                this.props.change(formName, `shapes.${activeShapeId}`, {
                    ...activeShape,
                    width: activeShape.width ? activeShape.width * newZoom : activeShape.width,
                    height: activeShape.height ? activeShape.height * newZoom : activeShape.height,
                    points: isPointShapeType(activeShape.type) ? scalePoints(activeShape.points, newZoom, newZoom) : activeShape.points,
                    brush_strokes: activeShape.type === BRUSH_TYPE && typeof activeShape.brush_strokes !== 'undefined' ? scaleBrushStrokes(activeShape.brush_strokes, newZoom, newZoom) : undefined,
                    text_fontsize: activeShape.text_fontsize ? abs(round(activeShape.text_fontsize * newZoom)) : activeShape.text_fontsize,
                })
            }
        } else {
            this.props.updateZoom(newZoom)
            if (typeof translate !== "undefined") {
                this.props.updateTranslate(translate)
            }
        }
    }

    handleStepWheelZoom = (event, d) => {
        const { activeShapeId } = this.props
        const zOut = 1 - ZOOM_STEP
        const zIn = 1 + ZOOM_STEP

        if (activeShapeId) {
            if (typeof event.wheelDelta !== 'undefined') {
                event.preventDefault()
                this.handleZoom(event.wheelDelta < 0 ? zOut : zIn)
            } else if (typeof event.deltaY !== 'undefined') {
                event.preventDefault()
                this.handleZoom(event.deltaY > 0 ? zOut : zIn)
            }
        }
    }

    handleWheelZoom = (event) => {
        const nearestZoom = round(event.transform.k / ZOOM_STEP) * ZOOM_STEP
        this.handleZoom(nearestZoom)
        this.handleWindowResized()
    }

    componentDidMount() {
        const { settingsForm, form } = this.props

        if (form && form.size && form.name && form.size?.width && form.size?.height) {
            document.title = `FIE: ${form.name} ${form.size.width}x${form.size.height}`
        }

        //TODO: WHEEL ZOOM NOT WORKING TOGETHER WITH MOUSE-SELECT if on the same DOM element!!!!
        const svgEl = document.getElementById('image')
        if (svgEl && d3.select(svgEl)) {
            if (!settingsForm.disable_wheelzoom) {
                const box = svgEl.getBoundingClientRect()
                d3.select(svgEl)
                    .on("wheel", (event, d) => this.handleStepWheelZoom(event, d))
                    .call(
                        d3.zoom()
                            .filter(() => (!this.props.activeShapeId && !settingsForm.disable_wheelzoom))
                            //.extent([[0, 0], [box.width, box.height]])
                            //.translateExtent([[0, 0], [box.width, box.height]]) //topleft and bottomright -- max and min translate
                            .scaleExtent([MIN_ZOOM, MAX_ZOOM])
                            .on("zoom", (event) => this.handleWheelZoom(event))
                    )
                    .on("dblclick.zoom", null)
                console.debug('wheel zoom is ENABLED')
            } else {
                console.debug('wheel zoom is DISABLED')
            }
        }

        document.addEventListener("keydown", this.handleKeyDown)
        window.addEventListener('resize', this.handleWindowResized)

        const target = document.getElementById('image')
        if (target) {
            const boundingBox = target.getBoundingClientRect()
            this.setState({ canvasBox: boundingBox })
        }

        this.handleWindowResized()
        this.updateGuidelinesStateForAllShapes(form.shapes)    //mozna jako parametr davat updatedShapes nebo debounced?
    }

    isActiveAndTextCursorType = (): boolean => {
        if (!this.props.activeShapeId || !this.props.shapes || this.props.editMode !== 'text') {
            return false
        }

        const activeShape = this.props?.shapes[this.props?.activeShapeId] as ShapeType
        return activeShape && !NO_TEXT_CURSOR_TYPES.includes(activeShape.type)
    }

    deleteActiveShapeOrGroup = () => {
        const { activeShapeId, activeGroupId, selectedLayers, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const shapes = { ...form.shapes }

        let deleteIndexes = []

        if (activeShapeId) {
            deleteIndexes.push(activeShapeId)
            this.props.setActiveShapeId(null)
        } else if (selectedLayers.length > 0) {
            deleteIndexes.push(...selectedLayers)

            //delete group from groups
            if (activeGroupId) {
                const newGroups = form.groups.filter(g => g.index !== activeGroupId)
                this.props.setActiveGroupId(null)
                this.props.change(formName, 'groups', newGroups)
            }

            this.props.selectLayers()
        }

        const newShapes = omitBy(shapes, (value, key) => deleteIndexes.includes(key))
        this.props.change(formName, "shapes", newShapes)

        this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)
    }

    handleAddShape = () => {
        this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)
    }

    handleKeyDown = (event) => {
        const { canvasBox} = this.state
        const { canvasTranslate, canvasZoom, activeShapeId, form, isAlt } = this.props

        const step = 50

        if (['TEXTAREA', 'INPUT'].includes(event.target.tagName)) {
            return false
        }

        const maxX = canvasBox && canvasBox.width ? .5 * canvasZoom * canvasBox.width : .5 * window.innerWidth
        const maxY = canvasBox && canvasBox.height ? .5 * canvasZoom * canvasBox.height : window.innerHeight

        const activeShape = this.props.shapes[activeShapeId] as ShapeType
        const isLocked = this.props.lockedLayers && this.props.lockedLayers.includes(activeShape?.index)

        switch (event.keyCode) {
            case PLUS_KEY:
                if (activeShapeId) {
                    event.preventDefault()
                    this.handleZoom(1 + ZOOM_STEP)
                } else {
                    event.preventDefault()
                    this.handleZoom(canvasZoom + ZOOM_STEP)
                }
                break
            case MINUS_KEY:
                if (activeShapeId) {
                    event.preventDefault()
                    this.handleZoom(1 - ZOOM_STEP)
                } else {
                    event.preventDefault()
                    this.handleZoom(canvasZoom - ZOOM_STEP)
                }
                break
            case RIGHT_ARROW_KEY:
                if (!activeShape && canvasTranslate.x < maxX) {
                    event.preventDefault()
                    this.props.updateTranslate({ ...canvasTranslate, x: canvasTranslate.x + step })
                }
                break
            case LEFT_ARROW_KEY:
                if (!activeShape && canvasTranslate.x >= -maxX) {
                    event.preventDefault()
                    this.props.updateTranslate({ ...canvasTranslate, x: canvasTranslate.x - step })
                }
                break
            case DOWN_ARROW_KEY:
                if (!activeShape && canvasTranslate.y < maxY) {
                    event.preventDefault()
                    this.props.updateTranslate({ ...canvasTranslate, y: canvasTranslate.y + step })
                }
                break
            case UP_ARROW_KEY:
                if (!activeShape && canvasTranslate.y > -maxY) {
                    event.preventDefault()
                    this.props.updateTranslate({ ...canvasTranslate, y: canvasTranslate.y - step })
                }
                break
            case DELETE_KEY:
                if (!isLocked && !this.isActiveAndTextCursorType() && (!activeShape || !isPointShapeType(activeShape.type))) {
                    event.preventDefault()
                    this.deleteActiveShapeOrGroup()
                }
                break
            case INSERT_KEY:
                if (this.props.activeView !== ACTIVE_VIEW_EDIT_SOURCE_IMAGE && !form.is_keep_size) {
                    event.preventDefault()
                    this.handleAddShape()
                }
                break;
            default:
                break
        }

        return true
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleKeyDown)
        window.removeEventListener('resize', this.handleWindowResized)
    }

    handleWindowResized = () => {
        const { canvasTranslate, canvasZoom } = this.props

        const wrapper = document.getElementById('canvas-wrapper')
        const svgImage = document.getElementById('image')

        if (wrapper && svgImage) {
            const wrapperSize = wrapper.getBoundingClientRect()
            const svgSize = svgImage.getBoundingClientRect()

            const width = svgSize.width / canvasZoom
            const height = svgSize.height / canvasZoom

            this.props.updateTranslate({ ...canvasTranslate, y: .5 * wrapperSize.height - .5 * height })
        }
    }

    updateGroupSizeAndPos = () => {
        this.setState({
            calculatedGroupSizeAndPosition: { ...calculateGroupSizeAndPosition() },
            deltaPositions: { ...initDeltaPositions },
        })
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (prevProps && Object.keys(prevProps).length > 0) {
            const prevForm = prevProps.form
            const thisForm = this.props.form

            //const activeShape = this.props.activeShapeId && thisForm.shapes ? thisForm.shapes[this.props?.activeShapeId] : null
            //const prevActiveShape = prevProps?.activeShapeId && prevForm.shapes ? prevForm.shapes[prevProps?.activeShapeId] : null

            const shapesDiff = prevForm.shapes && JSON.stringify(prevForm.shapes) !== JSON.stringify(thisForm.shapes)
            const selectedLayersDiff = prevProps.selectLayers && JSON.stringify(prevProps.selectedLayers) !== JSON.stringify(this.props.selectedLayers)

            if (selectedLayersDiff || shapesDiff) {
                this.updateGroupSizeAndPos()
            } else if (prevForm && prevForm.size && (prevForm.size?.height !== thisForm.size?.height || prevForm.size?.width !== thisForm.size?.width)) {
                this.handleWindowResized()
            } else if (prevProps.activeShapeId !== this.props.activeShapeId) {
                this.updateGuidelinesStateForAllShapes(thisForm.shapes) //debug???
            }
        }
    }

    updateGroupedShapesInStore = () => {
        const { groupDeltaPositions } = this.state
        const { selectedLayers, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const {groupWidth, groupHeight, middleX, middleY, groupAngle} = this.state.calculatedGroupSizeAndPosition

        const groupDeltaWidth = groupDeltaPositions.x2 - groupDeltaPositions.x1
        const groupDeltaHeight = groupDeltaPositions.y2 - groupDeltaPositions.y1

        const groupScaleX = (groupWidth + groupDeltaWidth) / groupWidth
        const groupScaleY = (groupHeight + groupDeltaHeight) / groupHeight

        const groupScaleAvg = (groupScaleX + groupScaleY) / 2

        const oldGroupX1 = middleX - groupWidth / 2
        const oldGroupY1 = middleY - groupHeight / 2

        const newGroupX1 = oldGroupX1 + groupDeltaPositions.x1
        const newGroupY1 = oldGroupY1 + groupDeltaPositions.y1

        let newShapes = [];
        const orderedShapes = sortBy(Object.keys(form.shapes).map(o => form.shapes[o]), [o => o.priority])
        orderedShapes.forEach((shape: ShapeType) => {
            if (selectedLayers.includes(shape.index)) {
                const isAspectRatio = shape.is_aspect_size_ratio
                const angle = shape.angle || 0
                const scaleX = isAspectRatio ? groupScaleAvg : groupScaleX
                const scaleY = isAspectRatio ? groupScaleAvg : groupScaleY

                const { width, height } = getShapeSize(shape)

                const scaledSize = getScaledShapeSizeAndAngle(width, height, scaleX, scaleY, angle)
                const updatedMaskObjects = recalcClipMaskSizeAndPositions(groupDeltaPositions, width, height, shape.clip_mask, true)

                const newShapeX = round((shape.x - oldGroupX1) * groupScaleX + newGroupX1)
                const newShapeY = round((shape.y - oldGroupY1) * groupScaleY + newGroupY1)

                const alphaRadian = groupAngle / 180 * PI

                const c = cos(alphaRadian)
                const s = sin(alphaRadian)

                const A = shape.x - newShapeX
                const B = shape.y - newShapeY

                const newShapeXX = shape.x - A*c + B*s
                const newShapeYY = shape.y - A*s - B*c

                newShapes[shape.index] = {
                    ...shape,
                    x: newShapeXX,
                    y: newShapeYY,
                    angle: scaledSize.angle,    // new angles
                    width: scaledSize.width,
                    height: scaledSize.height,
                    clip_mask: shape.clip_mask ? JSON.stringify(updatedMaskObjects) : shape.clip_mask,
                    points: typeof shape.points !== 'undefined' ? scalePoints(shape.points, groupScaleX, groupScaleY) : undefined,
                    brush_strokes: typeof shape.brush_strokes !== 'undefined' ? scaleBrushStrokes(shape.brush_strokes, groupScaleX, groupScaleY) : undefined,
                    text_fontsize: shape.text_fontsize ? abs(round(shape.text_fontsize*groupScaleAvg)) : shape.text_fontsize,
                }
            } else {
                newShapes[shape.index] = { ...shape }
            }
        })

        this.props.change(formName, "shapes", { ...form.shapes, ...newShapes })
        this.setGroupDeltaPositions({...initDeltaPositions})
    }

    updateShapesPositionsAndAnglesInStore = () => {
        const { groupDeltaAngle, calculatedGroupSizeAndPosition } = this.state
        rotateSelectedShapes(groupDeltaAngle, calculatedGroupSizeAndPosition.middleX, calculatedGroupSizeAndPosition.middleY)
        this.setState({
            groupDeltaPositions: { ...initDeltaPositions },
            groupDeltaAngle: 0
        })
    }

    renderClipMasks = (size: SizeType) => {
        const { shapes } = this.props
        const {deltaPositions} = this.state

        if (!shapes || (Array.isArray(shapes) && shapes.length === 0)) {
            return;
        }

        return <React.Fragment>
            {map(this.props.shapes, (shape) => {
                if (!shape?.clip_mask || !isJson(shape.clip_mask)) {
                    return;
                }
                const { width, height } = getShapeSize(shape)

                const isSelected = this.isSelected(shape.index)
                const objectId = `shape_clip_mask_${shape.index}`

                const updatedMaskObjects = recalcClipMaskSizeAndPositions(deltaPositions, width, height, shape.clip_mask, isSelected)

                const addWidth = isSelected ? deltaPositions.x2 - deltaPositions.x1 : 0
                const addHeight = isSelected ? deltaPositions.y2 - deltaPositions.y1 : 0

                const newWidth = width + addWidth
                const newHeight = height + addHeight

                const transform = shape.type !== SOURCE_IMAGE_TYPE ? `translate(${-.5*newWidth}, ${-.5*newHeight})` : undefined

                return <clipPath key={objectId} id={objectId} transform={transform}>
                    {updatedMaskObjects.map((maskObject, idx) => {
                        return <React.Fragment key={`clip_path_${idx}_${shape.index}`}>
                            {renderClipMaskShape(maskObject, false)}
                        </React.Fragment>
                    })}
                </clipPath>
            })}
        </React.Fragment>
    }

    isSelected = (shapeIndex: string): boolean => {
        const { selectedLayers, activeShapeId } = this.props
        return selectedLayers.length > 0 ? selectedLayers.includes(shapeIndex) : shapeIndex === activeShapeId
    }

    renderXORMasks(size: SizeType) {
        const {deltaPositions} = this.state
        const { shapes } = this.props

        if (!shapes || (Array.isArray(shapes) && shapes.length === 0)) {
            return;
        }

        return <React.Fragment>
            {map(this.props.shapes, (shape) => {
                if (!shape?.clip_mask || !isJson(shape.clip_mask)) {
                    return;
                }
                const { width, height } = getShapeSize(shape)
                const isSelected = this.isSelected(shape.index)

                const objectId = `shape_xor_mask_${shape.index}`
                const filterId = `shape_xor_me_${shape.index}`

                const transformX = shape.type !== SOURCE_IMAGE_TYPE ? -width/2 : 0
                const transformY = shape.type !== SOURCE_IMAGE_TYPE ? -height/2 : 0

                //TODO: test <mask maskContentUnits="objectBoundingBox" ...></mask>
                const updatedMaskObjects = recalcClipMaskSizeAndPositions(deltaPositions, width, height, shape.clip_mask, isSelected)
                return <React.Fragment key={objectId}>
                    <mask id={filterId}>
                        <rect x={transformX} y={transformY} width={width} height={height} fill="white" />
                        {updatedMaskObjects.map((maskObject, idx) => <React.Fragment key={`xor_path_${idx}_${shape.index}`}>
                            {renderClipMaskShape(maskObject, false, true, transformX, transformY)}
                        </React.Fragment>)}
                    </mask>

                    {/* <filter id={filterId}>
                        <feImage xlinkHref={`#${objectId}`} width={width} height={height} />
                        <feComposite operator="xor" in="SourceGraphic"/>
                    </filter> */}
                </React.Fragment>
            })}
        </React.Fragment>
    }

    handleRotateShape = (shape: ShapeType, deltaAngle: number) => {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const newAngle = round((shape.angle || 0) + deltaAngle) % 360
        this.props.change(formName, `shapes.${shape.index}.angle`, newAngle)

        this.setState({ deltaAngle: 0 })
        this.updateGuidelinesStateForAllShapes(form.shapes)    //mozna jako parametr davat updatedShapes nebo debounced?
    }

    handleResizeOrMoveShape = (shape: ShapeType, deltaPositions: DeltaPositionsType) => {
        const { form, isAlt } = this.props
        const formName = getFormName(isAlt)

        if (!shape) {
            console.debug('no shape or index', shape?.index)
            return;
        }

        const updatedShape = getUpdatedShapeOrFontSize(shape, deltaPositions)

        if (updatedShape) {
            this.props.change(formName, `shapes.${shape.index}`, {
                ...updatedShape,
            })
        }

        this.setState({ deltaPositions: { ...initDeltaPositions } })
        this.updateGuidelinesStateForAllShapes(form.shapes)    //mozna jako parametr davat updatedShapes nebo debounced?
    }

    renderShapes(size: SizeType, randomProduct: RandomProduct, groupDeltaWidth: number, groupDeltaHeight: number): JSX.Element | JSX.Element[] {
        const { groupDeltaPositions, groupDeltaAngle, calculatedGroupSizeAndPosition, deltaAngle, deltaPositions } = this.state
        const { mouseOverShape, activeView, lockedLayers, selectedLayers, activeShapeId, guides } = this.props

        const { form, isAlt, levels, levelsMode } = this.props

        const sorted = sortBy(this.props.shapes, [(shape) => {
            return new Number(-shape.priority)
        }]).filter(shape => (shape.is_hidden !== 1))

        const sourceClipPath = this.props.shapes && this.props.shapes[SOURCE_IMAGE_INDEX]?.clip_mask ? `url(#shape_clip_mask_${SOURCE_IMAGE_INDEX})` : undefined
        const sourceXORFilterPath = this.props.shapes && this.props.shapes[SOURCE_IMAGE_INDEX]?.clip_mask ? `url(#shape_xor_me_${SOURCE_IMAGE_INDEX})` : undefined

        const sourceImageLayer = this.props.shapes && this.props.shapes[SOURCE_IMAGE_INDEX]?.invert_clip_mask ?
            <g id={'source-image-mask'} key={'source-image'} mask={sourceXORFilterPath}>
                <SourceImageSvg
                    levels={levels}
                    levelsMode={levelsMode}
                    showOverlap={this.props.showOverlap}
                    isDraggable={true}
                    deltaAngle={deltaAngle}
                    setDeltaAngle={this.setDeltaAngle}
                    deltaPositions={deltaPositions}
                    setDeltaPositions={this.setDeltaPositions}
                />
            </g> :
            <g id={'source-image-clip'} key={'source-image'} clipPath={sourceClipPath}>
                <SourceImageSvg
                    levels={levels}
                    levelsMode={levelsMode}
                    showOverlap={this.props.showOverlap}
                    isDraggable={true}
                    deltaAngle={deltaAngle}
                    setDeltaAngle={this.setDeltaAngle}
                    deltaPositions={deltaPositions}
                    setDeltaPositions={this.setDeltaPositions}
                />
            </g>

        if (this.props.shapes && Array.isArray(this.props.shapes) && this.props.shapes.length === 0) {
            return sourceImageLayer
        }

        const groupScaleX = calculatedGroupSizeAndPosition?.groupWidth ? (calculatedGroupSizeAndPosition.groupWidth + groupDeltaWidth) / calculatedGroupSizeAndPosition.groupWidth : 1
        const groupScaleY = calculatedGroupSizeAndPosition?.groupHeight ? (calculatedGroupSizeAndPosition.groupHeight + groupDeltaHeight) / calculatedGroupSizeAndPosition.groupHeight : 1

        const groupScaleAvg = (groupScaleX + groupScaleY) / 2

        const oldGroupX1 = calculatedGroupSizeAndPosition?.middleX - calculatedGroupSizeAndPosition?.groupWidth / 2
        const oldGroupY1 = calculatedGroupSizeAndPosition?.middleY - calculatedGroupSizeAndPosition?.groupHeight / 2

        const newGroupX1 = oldGroupX1 + groupDeltaPositions.x1
        const newGroupY1 = oldGroupY1 + groupDeltaPositions.y1

        const templateSize = getTemplateSize(form)

        return map(sorted, (shape) => {
            if (shape.type === SOURCE_IMAGE_TYPE && randomProduct && randomProduct.isLoaded) {
                return sourceImageLayer
            }

            if (form.is_keep_size) {
                return null
            }

            const isAspectRatio: boolean = shape.is_aspect_size_ratio || shouldAspectRatio(shape.type)
            const isPointType: boolean = isPointShapeType(shape.type)
            const isBrushType: boolean = shape.type === BRUSH_TYPE
            const isLocked: boolean = lockedLayers.includes(shape.index)
            const isDraggable: boolean = shape.is_draggable
            const isSelected: boolean = isDraggable && (selectedLayers.includes(shape.index) || shape.index === activeShapeId)
            const isMouseOverShape: boolean = mouseOverShape === shape.index
            const isInMultiselect: boolean = selectedLayers.length > 1 && selectedLayers.includes(shape.index) && isDraggable
            const isMultiTransform: boolean = !!(isInMultiselect && groupDeltaPositions && calculatedGroupSizeAndPosition.groupWidth && calculatedGroupSizeAndPosition.groupHeight)
            const isEmptyImageType: boolean = [CUSTOM_SET_TYPE, BADGE_TYPE, BADGE1_TYPE, BITMAP_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE].includes(shape.type) && shape.imageBlob === ""

            const className = `shape ${isDraggable ? `draggable-group ${SELECTABLE_CLASS}` : ''} ${isSelected ? 'selected-shape' : ''}`

            const shapeOpacity = shape.opacity && shape.opacity > 0 && shape.opacity < 100 ? shape.opacity / 100 : undefined
            const flip = (shape.is_flip ? -1 : 1)
            const flop = (shape.is_flop ? -1 : 1)
            const angle = (shape.angle ? shape.angle : 0)
            const scale = shape.scale ? shape.scale : 1

            const { width, height } = getShapeSize(shape)

            const scaleX = isAspectRatio ? groupScaleAvg : groupScaleX
            const scaleY = isAspectRatio ? groupScaleAvg : groupScaleY

            const scaledSize = getScaledShapeSizeAndAngle(width, height, scaleX, scaleY, angle)
            const rotateAngle = round((
                (isSelected ? scaledSize.angle : angle) +
                (isSelected ? deltaAngle : 0) +
                (isMultiTransform && groupDeltaAngle ? groupDeltaAngle : 0)
            ) % 360)

            let translateX = shape.x || 0
            let translateY = shape.y || 0

            if (isMultiTransform && isSelected) {
                const A = shape.x - calculatedGroupSizeAndPosition.middleX
                const B = shape.y - calculatedGroupSizeAndPosition.middleY

                const C = oldGroupX1 - newGroupX1     //toto funguje pouze na presun, ale ne na zmenu width!!!!
                const D = oldGroupY1 - newGroupY1

                const alpha = groupDeltaAngle / 180 * PI
                const beta = 0  //groupAngle / 180 * PI

                const ca = cos(alpha)
                const sa = sin(alpha)

                const cb = cos(beta)
                const sb = sin(beta)

                translateX += round(A * ca - B * sa) - A   //shape rotation
                translateY += round(A * sa + B * ca) - B

                translateX += round(C * cb - D * sb) - C   //group rotation
                translateY += round(C * sb + D * cb) - D

                //translateX = calculatedGroupSizeAndPosition.middleX + (A * ca - B * sa) + groupDeltaPositions.x1
                //translateY = calculatedGroupSizeAndPosition.middleY + (A * sa + B * ca) + groupDeltaPositions.y1
            }

            const showHandles = (isPointType && (!shape.points || shape.points.length < 2)) ? false : isSelected
            const showFrame = (isMouseOverShape && !this.props.isDragging) || isSelected
            const rotateHandleSize = getRotateHandleSize()

            const showDraggableRectangle = isMouseOverShape || (!isMultiTransform && isDraggable &&
                width !== null && height !== null && width > 1 && height > 1 &&
                !isEmptyImageType && shape.type !== BRUSH_TYPE && !(shape.type === EXTERNAL_IMAGE_SOURCE_TYPE && (shape.imageBlob === null || shape.imageBlob === '')))

            const lockUnlockButton = <g onClick={() => this.toggleLockLayer(shape.index)} width={rotateHandleSize} height={rotateHandleSize} style={{ cursor: 'pointer' }}>
                <rect x={0} y={0} width={rotateHandleSize} height={rotateHandleSize} fill="transparent" />
                {isLocked ? <IconLock size={rotateHandleSize} color={Theme.steelblue} /> : <IconLockOpen size={rotateHandleSize} color={Theme.steelblue} />}
            </g>

            const deleteButton = <g transform={`translate(${rotateHandleSize}, 0)`} onClick={() => this.deleteShape(shape.index)} width={rotateHandleSize} height={rotateHandleSize} style={{ cursor: 'pointer' }}>
                <rect x={0} y={0} width={rotateHandleSize} height={rotateHandleSize} fill="transparent" />
                <IconDelete size={rotateHandleSize} color={Theme.steelblue} />
            </g>

            const aspectRatioButton = <g onClick={() => this.toggleAspectRatio(shape)} width={rotateHandleSize} height={rotateHandleSize} style={{ cursor: 'pointer' }}>
                <rect x={0} y={0} width={rotateHandleSize} height={rotateHandleSize} fill="transparent" />
                {shape.is_aspect_size_ratio ? <IconChain size={rotateHandleSize} color={Theme.steelblue} /> : <IconChainBroken size={rotateHandleSize} color={Theme.steelblue} />}
            </g>



            return (
                <React.Fragment key={`render_shape_${shape.index}`}>
                    <Group className={`type_${shape.type ? shape.type.split(/(?=[A-Z])/).join('_').toLowerCase() : 'unknown'}`}>
                        <g className={className} transform={`translate(${translateX}, ${translateY}), rotate(${rotateAngle})`} id={`${SHAPE_ID_PREFIX}${shape.index}`} style={{ opacity: shapeOpacity }}>
                            <g className={'first-g'} transform={`scale(${flop * scale}, ${flip * scale})`}>
                                <Shape
                                    size={size}
                                    levels={levels}
                                    levelsMode={levelsMode}
                                    data={{ ...shape }}
                                    groupDeltaPositions={groupDeltaPositions}
                                    calculatedGroupSizeAndPosition={calculatedGroupSizeAndPosition}
                                    groupDeltaAngle={groupDeltaAngle}
                                    setGroupDeltaPositions={this.setGroupDeltaPositions}
                                    setgroupDeltaAngle={this.setgroupDeltaAngle}
                                    updateGroupedShapesInStore={this.updateGroupedShapesInStore}
                                    setMouseOverShape={this.props.setMouseOverShape}
                                    deltaAngle={deltaAngle}
                                    deltaPositions={deltaPositions}
                                    setDeltaAngle={this.setDeltaAngle}
                                    setDeltaPositions={this.setDeltaPositions}
                                    handleRotate={() => this.handleRotateShape(shape, deltaAngle)}
                                    handleResize={() => this.handleResizeOrMoveShape(shape, { ...deltaPositions, type: 'move' })}
                                />
                            </g>

                            <g className='second-g'>
                                {showDraggableRectangle &&
                                    <DraggableRectangle
                                        templateSize={templateSize}
                                        width={width}
                                        height={height}
                                        angle={angle}
                                        index={shape.index}
                                        x={translateX}
                                        y={translateY}
                                        isAspectRatio={isAspectRatio}
                                        isDragging={this.props.isDragging}
                                        isLocked={isLocked}
                                        deltaAngle={deltaAngle}
                                        deltaPositions={deltaPositions}
                                        setDeltaAngle={this.setDeltaAngle}
                                        setDeltaPositions={this.setDeltaPositions}
                                        handleRotate={() => this.handleRotateShape(shape, deltaAngle)}
                                        handleResize={(type: ResizeElementType) => this.handleResizeOrMoveShape(shape, { ...deltaPositions, type })}
                                        onDragStarted={() => {
                                            this.props.setDragging(true)
                                            this.props.setActiveShapeId(shape.index)
                                            this.props.setActiveGroupId(null)
                                        }}
                                        onDragEnded={() => this.props.setDragging(false)}
                                        guides={guides?.isShowGrid && guides?.isSnapOn && guides?.gridStep > 0 && shape.type !== CURVED_TEXT_TYPE ? guides : null}
                                        enablePointerEventsOnFrame={isPointType}   //important for all point types
                                        showRotateHandle={isSelected}
                                        showMoveArrows={isPointType || isBrushType}
                                        showHandles={showHandles}
                                        showFrame={showFrame}
                                        leftHandle={(!shouldAspectRatio(shape.type) && !EXCLUDE_ASPECT_SIZE_RATIO_TYPES.includes(shape.type)) ? aspectRatioButton : undefined}
                                        rightHandle={
                                            <React.Fragment>
                                                {lockUnlockButton}
                                                {deleteButton}
                                            </React.Fragment>
                                        }
                                        rightIsLockedHandle={lockUnlockButton}
                                    />
                                }
                            </g>
                        </g>
                    </Group>
                </React.Fragment>
            )
        })
    }

    unselectShape = (e) => {
        const { selectedLayers, activeShapeId, activeView, form } = this.props

        if (e.target && !e.ctrlKey) {
            e.preventDefault()

            const shapeType = activeShapeId ? form.shapes[activeShapeId]?.type : null
            const tagName = e.target instanceof Element ? e.target.tagName : null

            const targetIsEitherSourceImageOrDiv = ['image', 'DIV'].includes(tagName) &&
                !(tagName === 'image' && [EXTERNAL_IMAGE_SOURCE_TYPE, CUSTOM_SET_TYPE, BITMAP_TYPE, BADGE_TYPE, BADGE1_TYPE, IMAGE_FROM_ELEMENTS_TYPE].includes(shapeType))   //....otherwise other image elements are not selectable by clicking on it

            const shouldSwitchEditSource = activeView !== ACTIVE_VIEW_EDIT_SOURCE_IMAGE && targetIsEitherSourceImageOrDiv && !selectedLayers?.length
            const shouldSwitchEditShape = !targetIsEitherSourceImageOrDiv && !selectedLayers?.length && activeShapeId

            if (!shouldSwitchEditShape) {
                this.props.setActiveView(shouldSwitchEditSource ? ACTIVE_VIEW_EDIT_SOURCE_IMAGE : ACTIVE_VIEW_SHAPE_SELECTION)
                this.props.setActiveShapeId(null)
            }

            if (targetIsEitherSourceImageOrDiv) {   //unselect ne kdyz kliknu na tlacitko group ungroup
                this.props.setActiveGroupId(null)
                this.props.selectLayers([]) //on click without ctrl deselect all from multiselect
            }
        }
    }

    rotateByAngle = (coords: CoordsType, alphaDegrees: number = null): CoordsType => {
        const alphaRadians = (alphaDegrees || 0) / 180 * PI
        const c = cos(alphaRadians)
        const s = sin(alphaRadians)

        return {
            x: coords.x * c - coords.y * s,
            y: coords.x * s + coords.y * c,
        }
    }

    ungroup = () => {
        const { activeGroupId, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const activeGroup = activeGroupId ? find(form.groups, (g) => {
            return g.index === activeGroupId
        }) : null

        const newGroups = form.groups.filter(g => g.index !== activeGroup.index)

        this.props.selectLayers(activeGroup.list)
        this.props.setActiveGroupId(null)
        this.props.change(formName, 'groups', newGroups)
    }

    groupOrUngroup = (e, groupOrUngroup: boolean) => {
        e.preventDefault()
        this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)
        if (groupOrUngroup) {
            createGroupFromSelected()
        } else {
            this.ungroup()
        }
    }

    deleteSelected = () => {
        const { activeGroupId, selectedLayers, form, isAlt } = this.props

        const formName = getFormName(isAlt)
        const shapes = { ...form.shapes }

        let deleteIndexes = []
        if (selectedLayers.length > 0) {
            deleteIndexes.push(...selectedLayers)

            //delete group from groups
            if (activeGroupId) {
                const newGroups = form.groups.filter(g => g.index !== activeGroupId)
                this.props.setActiveGroupId(null)
                this.props.change(formName, 'groups', newGroups)
            }

            this.props.selectLayers()

            const newShapes = omitBy(shapes, (value, key) => deleteIndexes.includes(key))
            this.props.change(formName, "shapes", newShapes)
        }
    }

    deleteShape = (shapeId: string) => {
        const {form,isAlt} = this.props

        const formName = getFormName(isAlt)

        const newShapes = omitBy({ ...form.shapes }, (value, shapeIndex) => shapeIndex === shapeId)
        this.props.setActiveShapeId(null)
        this.props.change(formName, "shapes", newShapes)
    }

    toggleLockLayer = (shapeId: string) => {
        this.props.toggleLockLayer(shapeId)
    }

    toggleAspectRatio = (shape: ShapeType) => {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)
        const newValue = !shape.is_aspect_size_ratio

        this.props.change(formName, `shapes.${shape.index}.is_aspect_size_ratio`, newValue)
        if (shape.type === CIRCLE_TYPE && newValue) {
            this.props.change(formName, `shapes.${shape.index}.height`, shape.width)
        }
    }

    render() {
        const { randomProduct, guides, isDragging, canvasZoom, canvasTranslate, gradients, activeShapeId, selectedLayers, activeGroupId, activeView, editMode, form, isAlt } = this.props
        const { groupDeltaPositions, groupDeltaAngle, guideLines, activeShapeCorners, snappedToX, snappedToY, calculatedGroupSizeAndPosition } = this.state
        const { middleX, middleY, groupAngle, groupWidth, groupHeight } = calculatedGroupSizeAndPosition

        if (!form || Object.keys(form).length === 0) {
            return false
        }

        const templateSize = getTemplateSize(form)

        const rotateHandleSize = getRotateHandleSize()
        const guideCrossSize = getHandleSize()
        const guideLineStrokeWidth = guideCrossSize / 10

        const maxGuideLineDistanceX = 8 * guides.minApproachX  //debug this
        const maxGuideLineDistanceY = 8 * guides.minApproachY  //debug this

        const calcHeight = `calc(${round(canvasZoom * 100)}vh - 114px)`

        const stdDeviation = 3

        const { templateBackgroundColor, templateGradient } = getTemplateGradientAndBackground(form, randomProduct, gradients)

        const overlapLinesPatternLength = guides.gridStep
        const loadingClass = randomProduct.isLoading ? 'muk-helper-loading' : ''

        const activeShape = form.shapes && form.shapes[activeShapeId] ? form.shapes[activeShapeId] : null
        const isMultiSelect = this.isMultiselect()

        if (activeShapeId && activeShape && guideLines && activeShapeCorners && isDragging && guides && !guides.isShowGrid) {
            let horizontalGuidelinesWithDistances = []
            guideLines.y.forEach((y) => {
                const d = abs(y - activeShapeCorners.topLeft.y) //distance from the guideline to the top left corner of the active object
                const e = abs(y - activeShapeCorners.bottomRight.y)
                const f = abs(y - activeShapeCorners.middle.y)

                if (d <= maxGuideLineDistanceY) {
                    horizontalGuidelinesWithDistances.push({
                        y: y,
                        distance: d,
                    })
                }
                if (e <= maxGuideLineDistanceY) {
                    horizontalGuidelinesWithDistances.push({
                        y: y,
                        distance: e,
                    })
                }
                if (2 * f <= maxGuideLineDistanceY) {         //middle line 2x smaller distance !!!
                    horizontalGuidelinesWithDistances.push({
                        y: y,
                        distance: f,
                    })
                }
            })
            let verticalGuidelinesWithDistances = []
            guideLines.x.forEach((x) => {
                const d = abs(x - activeShapeCorners.topLeft.x)
                const e = abs(x - activeShapeCorners.bottomRight.x)
                const f = abs(x - activeShapeCorners.middle.x)

                if (d <= maxGuideLineDistanceX) {
                    verticalGuidelinesWithDistances.push({
                        x: x,
                        distance: d,
                    })
                }
                if (e <= maxGuideLineDistanceX) {
                    verticalGuidelinesWithDistances.push({
                        x: x,
                        distance: e,
                    })
                }
                if (2 * f <= maxGuideLineDistanceX) {         //middle line 2x smaller distance !!!
                    verticalGuidelinesWithDistances.push({
                        x: x,
                        distance: f,
                    })
                }
            })
        }

        const groupDeltaWidth = isMultiSelect ? (groupDeltaPositions.x2 - groupDeltaPositions.x1) : 0
        const groupDeltaHeight = isMultiSelect ? (groupDeltaPositions.y2 - groupDeltaPositions.y1) : 0

        const rotatedMiddleX = calculatedGroupSizeAndPosition ? middleX : 0
        const rotatedMiddleY = calculatedGroupSizeAndPosition ? middleY : 0

        const groupOrUngroup = selectedLayers.length > 1 && !activeGroupId
        const disableMouseSelect = activeShape && (activeView === ACTIVE_VIEW_EDIT_SHAPE && [BRUSH_TYPE, BEZIER_TYPE].includes(activeShape.type))

        const mx = groupDeltaPositions.index === 'group' ? 0 : .5 * (groupDeltaPositions.x2 + groupDeltaPositions.x1)
        const my = groupDeltaPositions.index === 'group' ? 0 : .5 * (groupDeltaPositions.y2 + groupDeltaPositions.y1)

        return (
            <GridCell
                className={`unselectable middle-column preview-canvas ${loadingClass}`}
                id={'canvas-wrapper'}
                unselectable="on"
                onContextMenu={(e) => this.unselectShape(e)}>

                <div
                    className={'container'}
                    ref={this.mouseSelectContainerRef}
                    onClick={(e) => {
                        if (!disableMouseSelect) {
                            this.unselectShape(e)
                        }
                    }}>

                    <svg
                        id="image"
                        viewBox={`${-stdDeviation / 2} ${-stdDeviation / 2} ${templateSize.width + stdDeviation} ${templateSize.height + stdDeviation}`}
                        width={`${(templateSize.width + stdDeviation)}px`}
                        height={`${(templateSize.height + stdDeviation)}px`}
                        transform={`translate(${(canvasTranslate.x)},${(canvasTranslate.y)}), scale(${canvasZoom})`}
                        style={{
                            maxHeight: calcHeight,
                            maxWidth: 'calc(100% - 20px)',
                            pointerEvents: disableMouseSelect || (activeView === ACTIVE_VIEW_EDIT_SOURCE_IMAGE) ? 'auto' : 'none',  //experimental
                        }}>

                        <defs id="google-fonts" />

                        <defs>
                            <filter id="shadow-box" width={templateSize.width + stdDeviation} height={templateSize.height + stdDeviation} x={-(templateSize.width + stdDeviation) / 2} y={-(templateSize.height + stdDeviation) / 2}>
                                <feDropShadow dx={0} dy={0} stdDeviation={stdDeviation} floodColor={'#3a3a3a'} floodOpacity={.8} />
                            </filter>
                            <pattern id="smallGrid" width={`${guides.gridStep / 10}`} height={`${guides.gridStep / 10}`} patternUnits="userSpaceOnUse">
                                <path d={`M ${guides.gridStep / 10} 0 L 0 0 0 ${guides.gridStep / 10}`} fill="none" stroke="gray" strokeWidth=".5" />
                            </pattern>
                            <pattern id="grid" width={`${guides.gridStep}`} height={`${guides.gridStep}`} patternUnits="userSpaceOnUse">
                                <rect width={`${guides.gridStep}`} height={`${guides.gridStep}`} fill="url(#smallGrid)" />
                                <path d={`M ${guides.gridStep} 0 L 0 0 0 ${guides.gridStep}`} fill="none" stroke="gray" strokeWidth="1" />
                            </pattern>
                            <pattern id="overlap-pattern" width={`${overlapLinesPatternLength}`} height={`${overlapLinesPatternLength}`} patternUnits="userSpaceOnUse">
                                <polygon stroke={OVERLAY_COLOR_NEGATIVE} fill={'transparent'} points={`0 0 ${overlapLinesPatternLength / 3} ${overlapLinesPatternLength / 3}`} />
                            </pattern>
                            <pattern id="overlap-pattern-2" width={`${overlapLinesPatternLength}`} height={`${overlapLinesPatternLength}`} patternUnits="userSpaceOnUse">
                                <polygon stroke={OVERLAY_COLOR_POSITIVE} fill={'transparent'} points={`0 ${overlapLinesPatternLength / 3} ${overlapLinesPatternLength / 3} 0`} />
                            </pattern>

                            {this.renderXORMasks(templateSize)}
                            {this.renderClipMasks(templateSize)}
                        </defs>

                        {templateGradient &&
                            <GradientDefs gradient={templateGradient} idx={templateGradient.id} />
                        }

                        <rect
                            className={'preview-background'}
                            id={'preview-background-canvas'}
                            width={(templateSize.width || 0)}
                            height={(templateSize.height || 0)}
                            fill={templateGradient ? GradientFillUrl(templateGradient.id) : templateBackgroundColor}
                            fillOpacity={templateGradient && templateGradient.opacity ? templateGradient.opacity / 100 : 1}
                            filter={'url(#shadow-box)'}
                        />

                        {this.renderShapes(templateSize, randomProduct ?? null, groupDeltaWidth, groupDeltaHeight)}

                        {isMultiSelect && groupWidth > 1 && groupHeight > 1 &&
                            <React.Fragment>
                                <Group transform={`translate(${rotatedMiddleX + mx},${rotatedMiddleY + my}), rotate(${groupDeltaAngle + groupAngle}, ${-mx}, ${-my})`}>
                                    <DraggableRectangle
                                        templateSize={templateSize}
                                        width={groupWidth}
                                        height={groupHeight}
                                        angle={groupAngle}
                                        index={'group'}
                                        x={rotatedMiddleX + mx}
                                        y={rotatedMiddleY + my}
                                        isDragging={this.props.isDragging}
                                        deltaAngle={groupDeltaAngle}
                                        deltaPositions={groupDeltaPositions}
                                        setDeltaAngle={this.setgroupDeltaAngle}
                                        setDeltaPositions={this.setGroupDeltaPositions}
                                        //isAspectRatio={!(this.props.userId && testUsers.includes(this.props.userId))}
                                        isAspectRatio={true}
                                        handleRotate={() => {
                                            this.updateShapesPositionsAndAnglesInStore()
                                            this.setState({
                                                snappedToX: null,
                                                snappedToY: null,
                                            })
                                        }}
                                        handleResize={(type: ResizeElementType) => {
                                            console.debug('handle resize multiselect, type is', type)
                                            this.updateGroupedShapesInStore()
                                        }}
                                        onDragStarted={() => {
                                            this.props.setDragging(true)
                                            this.props.setActiveShapeId(null)
                                            this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)
                                        }}
                                        onDragEnded={() => this.props.setDragging(false)}
                                        showRotateHandle={true}
                                        leftHandle={
                                            <g onClick={(e) => this.groupOrUngroup(e, groupOrUngroup)} width={rotateHandleSize} height={rotateHandleSize} style={{ cursor: 'pointer' }}>
                                                <rect x={0} y={0} width={rotateHandleSize} height={rotateHandleSize} fill="transparent" />
                                                <IconGroupUnGroup size={rotateHandleSize} color={Theme.steelblue} groupOrUngroup={groupOrUngroup} />
                                            </g>
                                        }
                                        rightHandle={
                                            <g onClick={() => this.deleteSelected()} width={rotateHandleSize} height={rotateHandleSize} style={{ cursor: 'pointer' }}>
                                                <rect x={0} y={0} width={rotateHandleSize} height={rotateHandleSize} fill="transparent" />
                                                <IconDelete size={rotateHandleSize} color={Theme.steelblue} />
                                            </g>
                                        }
                                        showMoveArrows={true}
                                        showHandles={true}
                                        showFrame={true}
                                    />
                                </Group>
                            </React.Fragment>
                        }

                        {/* {this.state.cursorXPos && this.state.cursorYPos &&
                            <text transform={`translate(${templateSize.width - 80},20)`} fill={iconDisabledColor}>
                                [{this.state.cursorXPos}, {this.state.cursorYPos}]
                            </text>
                        } */}

                        {guides && guides.isShowGuides && !guides.isShowGrid && guideLines && isDragging && guideLines.x && guideLines.y &&
                            <React.Fragment>
                                {snappedToX !== null &&
                                    <line
                                        x1={snappedToX}
                                        x2={snappedToX}
                                        y1={0}
                                        y2={templateSize.height}
                                        style={guideLinesStyle(guideLineStrokeWidth)}
                                    />
                                }

                                {snappedToY !== null &&
                                    <line
                                        x1={0}
                                        x2={templateSize.width}
                                        y1={snappedToY}
                                        y2={snappedToY}
                                        style={guideLinesStyle(guideLineStrokeWidth)}
                                    />
                                }

                                {/* start debug */}
                                {false && this.props.userId && testUsers.includes(this.props.userId) &&  //debug only
                                    <React.Fragment>
                                        {guideLines.y.map((y, hkey) => {
                                            return guideLines.x.map((x, vkey) => <React.Fragment key={`guideline_cross${hkey}_${vkey}`}>
                                                <g style={{ opacity: .2 }}>
                                                    <circle
                                                        cx={x}
                                                        cy={y}
                                                        r={guideCrossSize / 3}
                                                        strokeWidth={guideCrossSize / 100}
                                                        stroke={Theme.blue}
                                                        fill='none'
                                                    />
                                                    <line
                                                        x1={0}
                                                        x2={templateSize.width}
                                                        y1={y}
                                                        y2={y}
                                                        style={guideLinesStyle(.2)}
                                                        fill='red'
                                                    />
                                                    <line
                                                        x1={x}
                                                        x2={x}
                                                        y1={0}
                                                        y2={templateSize.height}
                                                        style={guideLinesStyle(.2)}
                                                        fill='red'
                                                    />
                                                </g>
                                            </React.Fragment>
                                            )
                                        })}

                                        {activeShapeCorners &&
                                            <React.Fragment>
                                                <rect
                                                    x={activeShapeCorners.topLeft.x}
                                                    y={activeShapeCorners.topLeft.y}
                                                    width={abs(activeShapeCorners.topLeft.x - activeShapeCorners.bottomRight.x)}
                                                    height={abs(activeShapeCorners.topLeft.y - activeShapeCorners.bottomRight.y)}
                                                    stroke='#00cc00'
                                                    fill='none'
                                                    strokeWidth={3}
                                                />

                                                <rect
                                                    x={activeShapeCorners.topLeft.x - guides.minApproachX}
                                                    y={activeShapeCorners.topLeft.y - guides.minApproachY}
                                                    width={abs(activeShapeCorners.topLeft.x - activeShapeCorners.bottomRight.x) + 2 * guides.minApproachX}
                                                    height={abs(activeShapeCorners.topLeft.y - activeShapeCorners.bottomRight.y) + 2 * guides.minApproachY}
                                                    stroke='#cc9600a0'
                                                    fill='none'
                                                    strokeWidth={1}
                                                />

                                                <rect
                                                    x={activeShapeCorners.topLeft.x + guides.minApproachX}
                                                    y={activeShapeCorners.topLeft.y + guides.minApproachY}
                                                    width={abs(activeShapeCorners.topLeft.x - activeShapeCorners.bottomRight.x) - 2 * guides.minApproachX}
                                                    height={abs(activeShapeCorners.topLeft.y - activeShapeCorners.bottomRight.y) - 2 * guides.minApproachY}
                                                    stroke='#cc9600a0'
                                                    fill='none'
                                                    strokeWidth={1}
                                                />

                                                <line
                                                    x1={activeShapeCorners.middle.x - abs(activeShapeCorners.topLeft.x - activeShapeCorners.bottomRight.x) / 2}
                                                    x2={activeShapeCorners.middle.x + abs(activeShapeCorners.topLeft.x - activeShapeCorners.bottomRight.x) / 2}
                                                    y1={activeShapeCorners.middle.y}
                                                    y2={activeShapeCorners.middle.y}
                                                    style={{ strokeWidth: 1, stroke: 'green' }}
                                                />
                                                <line
                                                    x1={activeShapeCorners.middle.x}
                                                    x2={activeShapeCorners.middle.x}
                                                    y1={activeShapeCorners.middle.y - abs(activeShapeCorners.topLeft.y - activeShapeCorners.bottomRight.y) / 2}
                                                    y2={activeShapeCorners.middle.y + abs(activeShapeCorners.topLeft.y - activeShapeCorners.bottomRight.y) / 2}
                                                    style={{ strokeWidth: 1, stroke: 'green' }}
                                                />

                                                {activeShapeCorners.allRotatedPoints && activeShapeCorners.allRotatedPoints.length === 4 &&
                                                    activeShapeCorners.allRotatedPoints.map((c, j) => <React.Fragment key={`c_${j}_${activeShape.index}`}>
                                                        <circle
                                                            cx={c.x}
                                                            cy={c.y}
                                                            r={10}
                                                            style={{ strokeWidth: 3, stroke: 'blue', fill: 'black' }}
                                                        />
                                                        <text style={{ fill: 'white', stroke: 'yellow', fontSize: '10px' }} x={c.x} y={c.y}>{j}</text>
                                                    </React.Fragment>)
                                                }
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                {/* end debug */}
                            </React.Fragment>
                        }

                        {guides && guides.isShowGrid &&
                            <rect width="100%" height="100%" fill="url(#grid)" style={{ pointerEvents: "none" }} />
                        }
                    </svg>

                    {(randomProduct.isLoading || this.props.isLoading) &&
                        <Div position="absolute" right="20px" bottom="0px" zIndex="100000">
                            <small style={{ color: "#aaa" }}>{trans("product_is_rendering")}</small>
                            <Loader>
                                <div className="progress-value"></div>
                            </Loader>
                        </Div>
                    }

                    {/* {(!disableMouseSelect && editMode !== 'text') &&   //this would disable doubleclick customEvent */}
                    {!disableMouseSelect &&
                        <ReactMouseSelect
                            containerRef={this.mouseSelectContainerRef}
                            itemClassName={SELECTABLE_CLASS}
                            onClickPreventDefault={true}
                            edgeSize={10}
                            startSelectionCallback={(e: MouseEvent) => {
                                //console.debug('start selecting, active shape is', this.props.activeShapeId, this.props.activeView, disableMouseSelect)
                                this.setState({ isSelecting: true })
                            }}
                            finishSelectionCallback={(items: Element[], e: MouseEvent) => {
                                //console.debug(`finish selection callback, the active shape is ${this.props.activeShapeId} view ${this.props.activeView}`, disableMouseSelect)
                                e.preventDefault()
                                if (!this.state.isSelecting) {
                                    if (!e.ctrlKey) {   //multiselect
                                        this.props.setActiveShapeId(SOURCE_IMAGE_INDEX)
                                    }
                                } else {
                                    this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)
                                    this.props.setActiveShapeId(null)
                                    this.props.setActiveGroupId(null)

                                    this.setState({
                                        calculatedGroupSizeAndPosition: {
                                            ...calculatedGroupSizeAndPosition,
                                            groupWidth: null,
                                            groupHeight: null,
                                        },
                                        groupDeltaPositions: { ...initDeltaPositions },
                                        groupDeltaAngle: 0,
                                        isSelecting: false,
                                    })

                                    let selectedLayersIndexes = []
                                    items.forEach(item => {
                                        const id = item.getAttribute('id')
                                        if (id && id.startsWith(SHAPE_ID_PREFIX)) {
                                            const shapeIndex = id.substring(SHAPE_ID_PREFIX.length)
                                            const isLocked = this.props.lockedLayers && this.props.lockedLayers.includes(shapeIndex)
                                            if (!isLocked) {
                                                selectedLayersIndexes.push(shapeIndex)
                                            }
                                        }
                                    })

                                    if (selectedLayersIndexes.length === 1) {
                                        this.props.setActiveShapeId(selectedLayersIndexes[0])
                                    }

                                    this.props.selectLayers(selectedLayersIndexes)
                                }
                            }}
                        />
                    }
                </div>
            </GridCell>
        )
    }
}

const guideLinesStyle = (guideLineStrokeWidth: number, color: string = iconDisabledColor) => ({
    stroke: color,
    strokeWidth: `${guideLineStrokeWidth}px`,
})

const Loader = css("div")({
    border: "1px solid #ddd",
    justifyContent: "flex-start",
    borderRadius: "100px",
    alignItems: "center",
    position: "relative",
    display: "flex",
    height: "10px",
    overflow: "hidden",
    " .progress-value": {
        animation: "load 3s normal infinite",
        borderRadius: "100px",
        background: "linear-gradient(144deg, rgba(252,70,107,0.5) 0%, rgba(63,94,251,0.5) 100%)",
        height: "10px",
        width: 0,
    },
    "@keyframes load": {
        "0%": { width: 0, transform: "translate3d(0,0,0)", },
        "50%": { width: "100%", transform: "translate3d(0,0,0)", },
        "100%": { transform: "translate3d(100%,0,0)", width: "100%", },
    },
})

export const OVERLAY_COLOR_POSITIVE = 'blue'
export const OVERLAY_COLOR_NEGATIVE = '#cac8c5'

const Group = css('g')({
    " .shape:not(.draggable-group)": {
        pointerEvents: "none"
    },
    " .draggable-group": {
        pointerEvents: 'auto',
        ' text': {
            pointerEvents: 'none',
        },
    },
    "&:hover .draggable-rectangle:not(.selected-shape)": {
        opacity: DRAGGABLE_RECTANGLE_OPACITY,   // !important?????
        fill: "#ccc",
        "> .draggable-arrow": {
            transition: "transform 0.8s",
            transform: "scale3d(1.2,1.2,1)",
            opacity: DRAGGABLE_ARROW_OPACITY,
        }
    },
    " .decorator-frame": {
        outline: "3px dashed #ccc",
        mixBlendMode: 'difference',
    },
    " .selected-shape .draggable-arrow": {
        transform: "scale3d(.8,.8,.9)",
    },
})

function mapStateToProps(state) {
    const formName = getFormName(state.isAlt)
    const form = selectFormValues(state, formName)
    const shapes = replaceDynamicTextWithProductData(form, state.randomProduct)   //is alt is in the state (redux)

    return {
        shapes: shapes,
        editMode: state.editMode,
        gradients: state.gradients,
        randomProduct: state.randomProduct,
        isAlt: state.isAlt,
        form: form,
        settingsForm: selectFormValues(state, 'settingsForm'),
        activeView: state.activeView,
        activeShapeId: state.activeShapeId,
        activeGroupId: state.activeGroupId,
        sourceImage: state.sourceImage,
        selectedLayers: state.selectedLayers,
        lockedLayers: state.lockedLayers,
        guides: state.guides,
        isDragging: state.isDragging,
        userId: state.project.data.user?.id,
    }
}

export default connect(mapStateToProps, {
    setDragging,
    setActiveView,
    setEditMode,
    setActiveShapeId,
    setActiveGroupId,
    selectLayers,
    toggleSelectLayer,
    toggleLockLayer,
    change,
})(ImagePreview)
